import * as E from 'fp-ts/lib/Either';

import { DockError } from '../errorHandler';

export const safeParseJson = <T>(str: string): E.Either<Error, T> =>
    E.tryCatch<Error, T>(
        () => JSON.parse(str),
        () => new DockError('parsing error')
    );
